import React, { useEffect, useState } from "react";
import PaginatedTable from "../common/PaginatedTable";
import DTIPages from "../common/DTIPages";
import DtiToolbar from "../common/DtiToolbar";
import DtiKpiGrid from "../common/DtiKpiGrid";
import DtiSectionHeading from "../common/DtiSectionHeading";
import DtiOverviewSkeleton from "../common/DtiSkeleton";
import {
  getJobInteractiveLessionRate,
  getInteractiveLessionRate,
  createJobInteractiveLessionRate,
} from "../api/api";

const KPI_HEADERS = [
  { id: "totalTeacherCreatedLecture", text: "Số giáo viên đã tạo bài giảng" },
  { id: "totalInteractiveLecture", text: "Số bài giảng có học sinh tương tác" },
  { id: "totalLecture", text: "Sô bài giảng đã tạo" },
];

const IFRAME_HEADERS = [
  { id: "user_name", text: "Họ và tên giáo viên", width: "100%" },
];

export default function TeacherLessionRate({ iframe = false }) {
  const [data, setData] = useState([]);
  const [kpi, setKpi] = useState({});
  const [isFetching, setIsFetching] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const applyData = (nextData) => {
    setData(nextData);
    setKpi({
      totalTeacherCreatedLecture: nextData?.totalTeacherCreatedLecture,
      totalInteractiveLecture: nextData?.totalInteractiveLecture,
      totalLecture: nextData?.totalLecture,
    });
  };
  useEffect(() => {
    let intervalId;
    const fetchData = async () => {
      setIsFetching(true);
      try {
        applyData(await getInteractiveLessionRate());

        const job = await getJobInteractiveLessionRate();
        if (["starting", "pending"].includes(job?.workflow_state)) {
          setIsLoading(true);
          intervalId = setInterval(async () => {
            const jobStatus = await getJobInteractiveLessionRate();
            if (jobStatus?.workflow_state === "done") {
              setIsLoading(false);
              clearInterval(intervalId);
              setIsFetching(true);
              try {
                applyData(await getInteractiveLessionRate());
              } finally {
                setIsFetching(false);
              }
            }
          }, 1000);
        }
      } finally {
        setIsFetching(false);
      }
    };
    fetchData();
    return () => clearInterval(intervalId);
  }, []);

  const handleJob = async () => {
    if (isLoading) return;
    setIsLoading(true);
    await createJobInteractiveLessionRate();
    const intervalId = setInterval(async () => {
      const job = await getJobInteractiveLessionRate();
      if (job?.workflow_state === "done") {
        setIsLoading(false);
        clearInterval(intervalId);
        setIsFetching(true);
        try {
          applyData(await getInteractiveLessionRate());
        } finally {
          setIsFetching(false);
        }
      }
    }, 1000);
  };

  const showSkeleton = isFetching || isLoading;

  return (
    <>
      {iframe ? (
        <PaginatedTable
          headers={IFRAME_HEADERS}
          rows={data?.dataTeacherCreatedLecture?.dataCreatedResult || []}
          perPage={15}
        />
      ) : showSkeleton ? (
        <DtiOverviewSkeleton kpiCount={3} />
      ) : (
        <>
          <DtiToolbar isLoading={isLoading} onRefresh={handleJob} />

          <DTIPages
            secondPage={
              <>
                <DtiSectionHeading>6.5.1 Chi tiết thống kê số giáo viên tạo bài giảng</DtiSectionHeading>
                <li style={{ marginLeft: '20px' }}>
                  Số giáo viên tạo bài giảng: {data?.dataTeacherCreatedLecture?.totalCreatedResult}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Danh sách giáo viên:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "user_name",
                        text: "Họ và tên giáo viên",
                        width: "100%",
                      },
                    ]
                  }
                  rows={data?.dataTeacherCreatedLecture?.dataCreatedResult}
                  perPage={10}
                />
                <DtiSectionHeading>6.5.2 Chi tiết thống kê số bài giảng có học sinh tương tác</DtiSectionHeading>
                <li style={{ marginLeft: '20px' }}>
                  Số bài giảng có học sinh tương tác: {data?.totalInteractiveLecture}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Danh sách giáo viên:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "id",
                        text: "Mã bài giảng",
                        width: "33.333%",
                      },
                      {
                        id: "title",
                        text: "Tên bài giảng",
                        width: "33.333%",
                      },
                      {
                        id: "count",
                        text: "Số lượt tương tác của học sinh",
                        width: "33.333%",
                      },
                    ]
                  }
                  rows={data?.dataInteractiveLecture}
                  perPage={10}
                />
                <DtiSectionHeading>6.5.3 Chi tiết thống kê số bài giảng giáo viên đã tạo</DtiSectionHeading>
                <li style={{ marginLeft: '20px' }}>
                  Dạng trang: {data?.dataLecture?.totalWiki}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataWiki}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng thảo luận: {data?.dataLecture?.totalDiscussion}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataDiscussion}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng công cụ bên ngoài: {data?.dataLecture?.totalExternalTool}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataExternalTool}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng thông báo: {data?.dataLecture?.totalAnnouncement}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataAnnouncement}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng bài tập: {data?.dataLecture?.totalAssignment}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataAssignment}
                  perPage={10}
                /> 
              </>
            }
            firstPage={
              <DtiKpiGrid
                items={KPI_HEADERS.map(({ id, text }) => ({
                  id,
                  label: text,
                  value: kpi[id],
                }))}
              />
            }
          />
        </>
      )}
    </>
  );
}
